import React, {Component} from 'react';
import LogoArea from "./logoArea";
import Menu from "../components/Menu";
import {connect} from "react-redux";
import { Scrollbars } from 'react-custom-scrollbars';
import {
    autoChangeNavigateStauts,
    changeNavigateStauts,
    loadNavigateData, refreshPage,
    shrinNavigateStauts,
    updataNavigateData
} from "../actions";
import {LOGO_HEIGHT, SHRIN_MIN_LENGTH} from "../constants";

class Navigate extends Component {

    componentDidMount() {
        if(!this.props.initNavigateData)//没有加载过的时候再去加载，避免每次请求都去加载
            this.props.loadNavigateData();
        window.addEventListener('resize', this.resize.bind(this));
    }

    state = {
        height: document.body.clientHeight - 175 - LOGO_HEIGHT
    };

    resize(){
        if(window.innerWidth < SHRIN_MIN_LENGTH){
            this.props.shrinNavigateStauts();
        }
        this.setState({
            height: document.body.clientHeight - 175 - LOGO_HEIGHT
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this.resize);
    }

    render() {
        console.log('-----navigate---',this.props.navigateData)
        return (
            <div style={{background:"#0855A5"}}>
                <LogoArea />
                    <Scrollbars style={{height:this.state.height}}>
                        {
                            this.props.navigateData && this.props.navigateData.map(
                                one=><Menu {...this.props} id={one.id} key={one.id} type={1}
                                           icon={one.icon} menuName={one.menuName}>
                                    {
                                        one.sons && one.sons.map(two=><Menu {...this.props} id={two.id} key={two.id}
                                                                            type={2} menuName={two.menuName}>
                                            {
                                                two.sons && two.sons.map(
                                                    three=><Menu {...this.props} id={three.id} key={three.id}
                                                                 type={3} menuName={three.menuName}>
                                                    </Menu>
                                                )
                                            }
                                        </Menu>)
                                    }
                                </Menu>
                            )
                        }
                    </Scrollbars>
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        checkMenuId: state.systemReducer.menuId,
        navigateData: state.systemReducer.navigateData,
        navigateStatus:state.systemReducer.navigateStatus,
        autoNavigateStatus: state.systemReducer.autoNavigateStatus,
        initNavigateData: state.systemReducer.initNavigateData,
        refersh: state.systemReducer.refersh
    }
}

export default connect(mapStateToProps, {
    loadNavigateData, updataNavigateData, changeNavigateStauts, autoChangeNavigateStauts, shrinNavigateStauts, refreshPage
})(Navigate);